export const PORTFOLIO_CONTENT = {
  portfolio: 'Portfolio',
  portfolios: 'Portfolios',
  portfolioInfo: 'Portfolio Info',
  portfolioName: 'Portfolio Name',
  portfolioMilestone: 'Portfolio Milestone',
  portfolioMilestones: 'Portfolio Milestones',
  portfolioProjects: 'Portfolio Projects',
  numberProjects: 'Number of projects',

  deletePortfolio: '',
  deletePortfolioDescription:
    'Are you sure you want to delete this portfolio? Projects that roll up to this portfolio will not be deleted.',

  portfolioMilestonesFormDescription:
    'When you create a Portfolio Milestone, it will appear on the Portfolio Page. Milestones can be edited and deleted from the Portfolio page or directly from the Portfolio Timeline.',
  portfolioLinkedFilesFormDescription:
    "You can add supporting materials and documentation for your Portfolio using ChangeSync's Linked Files. Think of Linked Files as shortcuts to your organizations repositories like Teams, SharePoint, or Dropbox.",

  portfolioMilestonesDescription:
    "Portfolio Milestones can be change-specific or related to the overall Portfolio. Once saved, they will also appear on your Portfolio's timeline. You can manage Milestones from here or the timeline.",
};
